import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"

const ArtistsContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section id="mm-artists" className={cx("pageContainer")} aria-label="Artists">
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default ArtistsContainer
